import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '~/auth/services/user/user.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private readonly userService: UserService,
    private readonly redirectionService: RedirectionService
  ) {}

  canActivate(): true | Promise<boolean> {
    if (!this.userService.getUser().isProfileComplete()) {
      return this.redirectionService.redirect('/checkout.information');
    }

    return true;
  }
}

export const ProfileCompleteGuard: CanActivateFn = ():
  | true
  | Promise<boolean> => {
  return inject(PermissionsService).canActivate();
};
